import { environment } from '@environment';

// URL BACK SERVICES

// // CLIENT FORMS SERVICE
export const PROXY_FORM_BASE_URL = `${environment.proxyApiUrl}forms`;

export const SURVIVAL_PENSION_REQUEST_URL = `${PROXY_FORM_BASE_URL}/pensionaries/survival`;
export const INHERITANCE_CALCULATION_REQUEST_URL = `${PROXY_FORM_BASE_URL}/pensionaries/inheritance`;
